import { connect } from 'react-redux';

import Footer from '../components/Footer/Footer';
import { pdfModalOpen } from '../components/PdfModal/actions';

const mapStateToProps = state => ({});

export default connect(mapStateToProps, { pdfModalOpen })(Footer);
